import { productTypes } from 'data'

export function getProductTypeConfig(product: any, additionalOptions?: any) {
  if (additionalOptions && additionalOptions.back === 'Closed Back') {
    return productTypes['Shado Elite Custom - Closed Back']
  } else if (
    additionalOptions &&
    additionalOptions.back === 'Full Closed Back'
  ) {
    return productTypes['Shado Elite Custom - Full Closed Back']
  } else {
    return productTypes[product.name]
  }
}

export function getSelectedColorForProductItem(item: any = {}) {
  return [
    ...(item.options || []),
    ...(item.optionalColors || []),
    ...(item.primaryColors || []),
  ].find((option: any) => !!option.selected)
}
